import type { WContactFormTranslations } from "./pl";

export const de: WContactFormTranslations = {
  noConfig: "Formular-Konfigurationsdaten fehlen.",
  crmModeWithoutModule: {
    body1: "Das Formular ist auf CRM-Versand konfiguriert, aber das Modul",
    moduleName: "m_crm_sales_support",
    body2:
      'ist in dieser Domain nicht aktiv. Aktiviere das Modul im Admin-Panel oder ändere den Versandmodus auf "E-Mail" in der Fensterkonfiguration.',
  },
  unknownSendMode: (mode) =>
    `Unbekannter Versandmodus in der Formular-Konfiguration: ${mode}.`,

  labels: {
    text: "Nachricht",
  },
  send: "Senden",
  sending: "Wird gesendet…",

  validation: {
    requiredField: (label) => `Feld "${label}" ist erforderlich.`,
    invalidEmail: "Ungültige E-Mail-Adresse.",
    requiredText: 'Das Feld "Nachricht" ist erforderlich.',
    requiredPersonalData:
      "Die Einwilligung zur Verarbeitung personenbezogener Daten ist erforderlich.",
  },

  status: {
    waitBeforeSubmit: (seconds) =>
      `Bitte warte noch ${seconds} Sekunden, bevor du absendest.`,
    rateLimit:
      "Zu viele Versuche von dieser IP-Adresse. Versuche es in Kürze erneut.",
    sendFailed: "Die Nachricht konnte nicht gesendet werden.",
    sendSuccess: "Nachricht gesendet, danke!",
    networkError: (message) => `Netzwerkfehler: ${message}`,
    networkErrorGeneric: "Netzwerkfehler beim Senden.",
  },
};
